export default "__VITE_ASSET__D5PsvHbY__"